import styles from "./PlanWizard.module.scss";
import { FormProvider } from "react-hook-form";
import { SingleSectionPageLayout } from "../../../../common/components/common/SingleSectionPageLayout";
import { usePlanWizardPage } from "./hooks/usePlanWizardPage";
import { IPlanWizardFormModel } from "./models/planWizardFormModel";
import { DefaultInputField } from "../../../../common/components/forms/inputs/InputField/DefaultInputField";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { nameof } from "ts-simple-nameof";
import { HeaderTitleSectionWithBackground } from "../../../../common/components/common/HeaderTitleSectionWithBackground";
import { DefaultFormSelectField } from "../../../../common/components/forms/inputs/dropdown/DefaultFormSelectField";
import { classNames } from "primereact/utils";
import { PageMode } from "../../../../common/types";
import { HiddenField } from "../../../../common/components/forms/inputs/hiddenField/HiddenField";
import { useAppContext } from "../../../../AppContext";
import { CurrencyType } from "../../../../common/enums";

interface IPlanWizardProps {
  pageMode: PageMode;
}

export const PlanWizard = ({ pageMode }: IPlanWizardProps) => {
  const {
    form,
    pageTitle,
    actionButtonLabel,
    metricOptions,
    isEdit,
    wizardInitialData,
    isVisitsInputDisabled,
    consumerTypeOptions,
    onSave,
    // onCheckboxChange,
  } = usePlanWizardPage(pageMode);

  const { isDesktopOrTablet, selectedStudio } = useAppContext();

  const children = (
    <>
      <div className={styles.root_fields}>
        <HiddenField name={nameof<IPlanWizardFormModel>((x) => x.id)} />
        <HiddenField name={nameof<IPlanWizardFormModel>((x) => x.studioId)} />

        <DefaultInputField
          name={nameof<IPlanWizardFormModel>((x) => x.name)}
          label="Име на плана"
          placeholder="Едномесечна карта за студенти"
          required
        />

        <div className={styles.root_section}>
          <HeaderTitleSectionWithBackground text={"Посещения"} />
          <div
            className={classNames(
              styles.root_section_inner_container,
              styles.root_section_inner_container_visits,
            )}
          >
            <DefaultInputField
              name={nameof<IPlanWizardFormModel>((x) => x.numberOfVisits)}
              placeholder={"2"}
              label={"Брой"}
              type="number"
              disabled={isVisitsInputDisabled}
            />

            {/* Todo: Figure out if this is going to be left or not */}
            {/* <DefaultToggle
              name={nameof<IPlanWizardFormModel>((x) => x.isUnlimitedVisits)}
              label="Неограничена"
              onChange={onCheckboxChange}
            /> */}
          </div>
        </div>

        <div className={styles.root_section}>
          <HeaderTitleSectionWithBackground text={"Времетраене"} />
          <div
            className={classNames(
              styles.root_section_inner_container,
              styles.root_section_inner_container_duration,
            )}
          >
            <DefaultInputField
              name={nameof<IPlanWizardFormModel>((x) => x.durationNumber)}
              placeholder={"30"}
              className={styles.root_section_inner_container_duration_input}
              type="number"
              width={"13%"}
              minWidth="50px"
            />
            <DefaultFormSelectField
              className={styles.root_section_inner_container_duration_dropdown}
              name={nameof<IPlanWizardFormModel>((x) => x.durationMetric)}
              options={metricOptions}
              width="20%"
              minWidth="121px"
            />
          </div>
        </div>

        <DefaultInputField
          name={nameof<IPlanWizardFormModel>((x) => x.price)}
          label="Цена"
          placeholder="99"
          type="number"
          currency={CurrencyType.EUR}
          required
        />

        {selectedStudio?.studioUsesDifferentPlanTypes && (
          <DefaultFormSelectField
            name={nameof<IPlanWizardFormModel>((x) => x.studioPlanTypeId)}
            label="Вид на плана"
            tooltip={!!isEdit ? "Това поле не може да бъде променяно." : ""}
            options={wizardInitialData?.planTypes}
            disabled={isEdit}
            filter
          />
        )}

        <DefaultFormSelectField
          name={nameof<IPlanWizardFormModel>((x) => x.consumerTypeId)}
          label="Целева група"
          tooltip={!!isEdit ? "Това поле не може да бъде променяно." : ""}
          options={consumerTypeOptions}
          disabled={isEdit}
          includeId={false}
          filter
        />
      </div>
      <div className={styles.root_buttons}>
        <DefaultButton label={actionButtonLabel} type="submit" />
      </div>
    </>
  );

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSave)}>
        <SingleSectionPageLayout
          title={pageTitle}
          className={styles.root}
          maxHeight={isDesktopOrTablet ? "80%" : "90%"}
          children={children}
        />
      </form>
    </FormProvider>
  );
};
